import { sessionStorageService } from "@/core/storage";

import { TRACKING_QUERY_PARAMS_STORAGE_KEY } from "../tracking.constants";
import { SearchParamsLike } from "../tracking.types";
import { extractTrackingQueryParams } from "../trackingQueryParams/trackingQueryParams";

export const persistTrackingQueryParams = (searchParams: SearchParamsLike): URLSearchParams => {
  const trackingParams = extractTrackingQueryParams(searchParams);

  if (typeof window === "undefined") {
    return trackingParams;
  }

  const serializedTrackingParams = trackingParams.toString();

  if (!serializedTrackingParams) {
    return trackingParams;
  }

  void sessionStorageService.setItem(TRACKING_QUERY_PARAMS_STORAGE_KEY, serializedTrackingParams);

  return trackingParams;
};

export const getEffectiveTrackingQueryParams = (): URLSearchParams => {
  if (typeof window === "undefined") {
    return new URLSearchParams();
  }

  const currentTrackingParams = extractTrackingQueryParams(
    new URLSearchParams(window.location.search),
  );

  if (currentTrackingParams.toString()) {
    return currentTrackingParams;
  }

  try {
    const storedTrackingParams = sessionStorageService.getItemSync<string>(
      TRACKING_QUERY_PARAMS_STORAGE_KEY,
    );

    if (!storedTrackingParams) {
      return new URLSearchParams();
    }

    return extractTrackingQueryParams(new URLSearchParams(storedTrackingParams));
  } catch {
    return new URLSearchParams();
  }
};
